/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@inject('projectDetailsStore')
@observer
class AssignedEngineers extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const { details, projectId }: any = this.props;

    const isLinkDisabled: Function = (len: number) =>
      `${'layout-button' + (len === 0 ? ' disabled' : '')}`;

    return (
      <React.Fragment>
        <h3>{t('general:users.assigned_to_project')}</h3>
        <table className="layout-table large-first-col">
          <tbody>
            <tr>
              <th colSpan="3">{t('general:user_plural')}</th>
            </tr>
            {typeof details === 'undefined'
              ? null
              : details.map((val: any) => {
                  return (
                    <tr key={val.id}>
                      <td>{val.name}</td>
                      <td className="layout-flex">
                        <div>
                          <span>
                            {val.assets.all} {t('general:asset', { count: val.assets.all })}
                          </span>
                          <Link
                            to={NavigationService.formulateReportViewUri('/assets', {
                              page: 1,
                              filters: [
                                { key: 'project', values: [projectId] },
                                { key: 'user', values: [val.id] },
                              ],
                            })}
                            className={isLinkDisabled(val.assets.all)}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={val.assets.all === 0}
                            >
                              {t('general:actions.view_asset', {
                                count: val.assets.all,
                              })}
                            </Button>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default AssignedEngineers;
